export default class ProjetoPessoal {
    
    constructor(model = null){

        this.empresaId = 0;
        this.projetoId = 0;
        this.pessoalId = 0;

        if (!model)
            return;
        
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.pessoalId = model.pessoalId;
        this.pessoal = model.pessoal;
    }

}